// Opens the ZenDesk help center in a new tab with Sierra auto-opened on arrival.

import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { submitZendeskSsoForm } from '../../services/zendesk-sso-service';
import { getPreferredLocale } from '../../intl/get-intl';
import { Segment } from '../../services/analytics-services/segment';
import { HelpCenterService } from '../../services/helpcenter-service';
import { ShippyEvents } from '../../tracking/tracking-constants';

export const OpenSierraSource = {
  FtuWizardHelp: 'ftu_wizard_help',
  HelpMenuChat: 'help_menu_chat',
  StoreErrorModal: 'store_error_modal',
  WalletApprovalNotification: 'wallet_approval_notification',
  WalletError: 'wallet_error',
} as const;

export type OpenSierraSource = (typeof OpenSierraSource)[keyof typeof OpenSierraSource];

const OPEN_CHAT_PARAM = 'open-chat=true';

// Route through the SSO POST so users arrive authenticated — Sierra won't load without a Zendesk session.
export const useOpenSierraInZendesk = (): ((source: OpenSierraSource) => Promise<void>) => {
  const locale = useSelector(getPreferredLocale);

  return useCallback(
    async (source: OpenSierraSource) => {
      const redirectTo = `${HelpCenterService.getHelpCenterUrlByLocale(locale)}?${OPEN_CHAT_PARAM}`;
      const didOpen = await submitZendeskSsoForm(HelpCenterService.getSignInRedirectUrl(redirectTo));
      if (didOpen) {
        Segment.trackEvent(ShippyEvents.SIERRA_HELP_CENTER_OPENED, { source });
      }
    },
    [locale],
  );
};
